import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowRight, User, Calendar } from 'lucide-react';
import { articleService } from '../services/api';

function ArticleDetail() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const articleRes = await articleService.getById(id);
        setArticle(articleRes.data);
      } catch (err) {
        setError('خطا در بارگذاری مقاله');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) return <div className="max-w-7xl mx-auto px-4 py-12 text-center">در حال بارگذاری...</div>;
  if (error) return <div className="max-w-7xl mx-auto px-4 py-12 text-center text-red-600">{error}</div>;
  if (!article) return <div className="max-w-7xl mx-auto px-4 py-12 text-center">مقاله یافت نشد</div>;

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <Link to="/articles" className="flex items-center gap-2 text-blue-600 hover:text-blue-800 mb-8">
        <ArrowRight size={20} />
        بازگشت به مقالات
      </Link>

      <article className="bg-white rounded-lg shadow-md p-8 mb-8">
        <div className="mb-6">
          <h1 className="text-3xl font-bold mb-4">{article.title}</h1>
          <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-4">
            <div className="flex items-center gap-2">
              <Calendar size={18} />
              {new Date(article.submissionDate).toLocaleDateString('fa-IR')}
            </div>
            <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
              article.status === 'Published' ? 'bg-green-100 text-green-800' :
              article.status === 'Under Review' ? 'bg-yellow-100 text-yellow-800' :
              'bg-gray-100 text-gray-800'
            }`}>
              {article.status}
            </span>
          </div>
        </div>

        <div className="mb-8 pb-8 border-b">
          <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
            <User size={20} />
            نویسندگان
          </h2>
          <div className="space-y-3">
            {article.articleAuthors && article.articleAuthors.map((aa) => (
              <div key={aa.authorId} className="bg-gray-50 p-4 rounded-lg">
                <p className="font-semibold">{aa.author.firstName} {aa.author.lastName}</p>
                <p className="text-sm text-gray-600">{aa.author.affiliation}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-8 pb-8 border-b">
          <h2 className="text-lg font-semibold mb-4">چکیده</h2>
          <p className="text-gray-700 leading-relaxed">{article.abstract}</p>
        </div>

        <div className="mb-8 pb-8 border-b">
          <h2 className="text-lg font-semibold mb-4">کلمات کلیدی</h2>
          <div className="flex flex-wrap gap-2">
            {article.keywords && article.keywords.split(',').map((keyword, index) => (
              <span key={index} className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                {keyword.trim()}
              </span>
            ))}
          </div>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-4">متن کامل</h2>
          <div className="bg-gray-50 p-6 rounded-lg text-gray-700 leading-relaxed whitespace-pre-wrap">
            {article.content}
          </div>
        </div>
      </article>


    </div>
  );
}

export default ArticleDetail;
